<template>
  <!-- 档次/计划列表 -->
  <div>
    <div class="tools-box" v-if="!look">
      <Button type="primary" @click="$refs.gradeAdditionsForm.open({}, 'add')">新增档次/计划</Button>
    </div>
    <Table :columns="columns" :data="gradeAdditions">
      <template slot-scope="{ row, index }" slot="action">
        <span class="table-btn" @click="$refs.gradeAdditionsForm.open(row, 'edit', index)">编辑</span>
        <span class="table-btn red" @click="del(row, index)">删除</span>
      </template>
    </Table>
    <!-- 新增、编辑 -->
    <grade-additions-form :gradeAdditions="gradeAdditions" :additionals="additionals" :productCode="productForm.productCode" ref="gradeAdditionsForm" />
  </div>
</template>
<script>
import gradeAdditionsForm from './gradeAdditionsForm';
export default {
  mixins: [],
  components: {
    gradeAdditionsForm
  },
  props: {
    look: null,
    productForm: null,
    additionals: null,
    gradeAdditions: null
  },
  data() {
    return {
      columns: []
    };
  },
  watch: {},
  mounted(){
    this.getColumns();
  },
  methods: {
    // 获取标头
    getColumns() {
      let columns = [
         {
          title: '序号',
          align: 'center',
          width: 80,
          type: 'index'
        },
        {
          title: '编号',
          key: 'gradeCode',
          align: 'center',
          minWidth: 130
        },
        {
          title: '名称',
          key: 'name',
          align: 'center',
          minWidth: 300,
        },
      ]
      if(!this.look) {
        columns.push({
          title: '操作',
          slot: 'action',
          align: 'center',
          width: '130',
          fixed: 'right'
        })
      }
      this.columns = columns;
    },
    del(row, index) {
      this.$notice.inquiry('是否确认删除此选项？').then(async () => {
        if (row.id && this.productForm.id) {
          this.$http({
            url: `/buz/gradeAddition/checkDel`,
            type: 'GET',
            data: {
              productCode: row.productCode,
              gradeCode: row.gradeCode,
            }
          }).then(res => {
            if (res.data) {
              this.gradeAdditions.splice(index, 1);
            } else {
              this.$notice.error('当前档次/计划已经配置费用，无法删除！');
            }
          });
        } else {
          this.gradeAdditions.splice(index, 1);
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
